import { Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext.tsx';
import { useTenant } from '@/context/TenantContext.tsx';
import { Sidebar } from './Sidebar.tsx';
import { Navbar } from './Navbar.tsx';

/**
 * AppLayout — shell principal para usuarios autenticados de un tenant.
 * Compone Sidebar (colapsable) + Navbar + area de contenido (<Outlet />).
 */
export function AppLayout() {
  const { user, logout } = useAuth();
  const { tenantSlug } = useTenant();

  // TenantContextValue expone tenantSlug (string | null), no un objeto tenant.
  const tenantName = tenantSlug ?? 'Mi Empresa';

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        background: 'var(--color-bg)',
        fontFamily: 'var(--font-sans, system-ui, sans-serif)',
      }}
    >
      <Sidebar tenantName={tenantName} />

      {/* Columna principal: navbar + contenido */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Navbar user={user} tenantName={tenantName} onLogout={logout} />
        <main
          style={{
            flex: 1,
            padding: '1.75rem 2rem',
            overflowY: 'auto',
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
